import { generateDynamicThemeToken } from '../../ThemeProvider';
import { getDynamicThemeToken } from './theme';
import { randomStr } from '../../Shared';
import { focusMaskClass } from '../../Shared/a11yUtils';
const componentName = 'Switch';
export const switchClasses = {
    root: `ui-Switch-root-${randomStr()}`,
    thumb: `ui-Switch-thumb`,
    track: `ui-Switch-track`,
    switchBase: `ui-Switch-switchBase`,
    checked: `ui-Switch-checked`,
    disabled: `ui-Switch-disabled`,
    loading: `ui-Switch-loading`,
};
export function getStyle(theme, opts) {
    const dynamicToken = getDynamicThemeToken(theme);
    const [token, tk] = generateDynamicThemeToken({
        componentName,
        theme,
        dynamicToken,
    });
    const size = token.size[opts.size];
    const { color } = token;
    const style = {
        width: tk(size.width),
        height: tk(size.height),
        padding: 0,
        borderRadius: tk(size.height),
        [`& .${switchClasses.thumb}`]: {
            boxSizing: 'border-box',
            width: tk(size.thumbSize),
            height: tk(size.thumbSize),
            lineHeight: `${tk(size.thumbSize)}px`,
            background: tk(color.thumb.default),
            boxShadow: tk(token.boxShadow.thumb),
            borderRadius: '50%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            alignSelf: 'center',
            color: tk(color.thumb.icon),
            // need a loading svg
            '&:before': {
                content: '""',
                position: 'absolute',
                width: '100%',
                height: '100%',
                left: 0,
                top: 0,
            },
            '& .ui-Switch-loading-icon': {
                display: 'block',
                fontSize: tk(size.thumbIcon),
                width: tk(size.thumbIcon),
                height: tk(size.thumbIcon),
                color: tk(color.unchecked.default),
            },
        },
        [`& .${switchClasses.track}`]: {
            borderRadius: tk(size.borderRadius),
            backgroundColor: tk(color.unchecked.default),
            opacity: 1,
            border: 0,
            transition: 'background .5s',
        },
        [`&:hover .${switchClasses.track}`]: {
            backgroundColor: tk(color.unchecked.hover),
        },
        [`&:hover .${switchClasses.switchBase}.${switchClasses.checked} + .${switchClasses.track}`]: {
            backgroundColor: tk(color.checked.hover),
        },
        [`& .${switchClasses.switchBase}`]: {
            padding: 0,
            margin: tk(size.thumbGap),
            '> input': {
                margin: 0,
                padding: 0,
                lineHeight: 'unset',
            },
            [`&.${switchClasses.checked}`]: {
                transform: `translateX(${size.thumbSize}px)`,
                [`& + .${switchClasses.track}`]: {
                    backgroundColor: tk(color.checked.default),
                    opacity: 1,
                    border: 0,
                },
                [`& .ui-Switch-loading-icon`]: {
                    color: tk(color.checked.default),
                },
            },
        },
        [`html.${focusMaskClass} &.${switchClasses.root}:focus-within, body.${focusMaskClass} &.${switchClasses.root}:focus-within`]: {
            boxShadow: tk(token.boxShadow.focus),
        },
        // active
        [`& .${switchClasses.switchBase}:active`]: {
            [`& + .${switchClasses.track}`]: {
                backgroundColor: tk(color.unchecked.active),
            },
            [`&.${switchClasses.checked} + .${switchClasses.track}`]: {
                backgroundColor: tk(color.checked.active),
                opacity: 1,
                border: 0,
            },
        },
        // disabled
        [`& .${switchClasses.switchBase}.${switchClasses.disabled}`]: {
            [`& + .${switchClasses.track}`]: {
                backgroundColor: tk(color.unchecked.disabled),
                opacity: 1,
            },
            [`&.${switchClasses.checked} + .${switchClasses.track}`]: {
                backgroundColor: tk(color.checked.disabled),
                opacity: 1,
                border: 0,
            },
            [`& .${switchClasses.thumb}`]: {
                background: tk(color.thumb.disabled),
            },
        },
    };
    return style;
}
